import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Item } from './dropdown.models';

@Component({
  selector: 'app-dropdown',
  standalone: false,
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {

  @Input() list: Item[] = [];
  @Input() placeholder: string;
  @Input() showSearch = true;
  @Input() showError = false;
  @Input() isPopover = false;
  @Input() isSingleSelect = false;
  @Output() itemChange = new EventEmitter<any>(null);
  

  filterList: Item[] = [];
  private searchText = '';
  dropdownVisible:boolean=true;

  get search(): string {
    return this.searchText;
  }

  set search(searchText: string) {
    this.searchText = searchText;

    const search = this.searchText.toLowerCase();
    if (!search) {
      this.filterList = [...this.list];
      return;
    }
    this.filterList = this.list.filter(i => i.name.toLowerCase().indexOf(search) !== -1);
  }

  get all(): Item {
    if(this.list !== undefined) {
    return this.list.find(i => i.id === 0);
    }
  }

  get selected(): string {
    if(this.list !== undefined) {
    return this.all && this.all.checked ? this.all.name :
      this.list.filter(i => i.checked && i.visible).map(i => i.name).join(', ');
    }
  }

  get isEmpty(): boolean {
    return this.filterList.filter(i => i.visible).length === 0;
  }

  ngOnInit(): void {
    this.filterList = [...this.list];
  }

  ngOnChanges(): void {
    this.filterList = [...this.list];
  }

  onChange($event: any, item: Item): void {
    const checked = $event.target.checked || this.isSingleSelect;
    const index = this.list.findIndex(i => i.id === item.id);
    if (item.id === 0) {
      for (const iterator of this.list) {
        iterator.checked = checked;
      }
    }
     else {
      if (this.isSingleSelect) {
        this.list = this.list.map(k => ({ ...k, checked: false }));
      }
      this.list[index].checked = checked;
      

      /* istanbul ignore else*/
      if (this.all) {
        /* istanbul ignore else*/
        if (this.all.checked) {
          this.all.checked = false;
        }
        const allChecked = this.list.filter(i => i.id !== 0).every(i => i.checked);
        this.all.checked = allChecked;
      }
    }
    if(this.isSingleSelect){
      this.dropdownVisible=!this.dropdownVisible;
    }


    this.itemChange.emit({
      $event,
      item
    });
  }

}
